import React, { useState, useEffect } from 'react'

import { Modal } from 'react-bootstrap'

// import { HttpService, API, swal, Messages } from '../../config/react'

const VirtualRingRequestDetail = (props) => {
  console.log(props)

  const [data, setData] = useState()
  const [isForceUpdate, setForceUpdate] = useState(false)

  useEffect(() => {
    setData(props.props?.data)
    setForceUpdate(!isForceUpdate)
  }, [])

  useEffect(() => {
    setForceUpdate(!isForceUpdate)
  }, [data])

  const closeModal = () => {
    props.onCloseModal(true)
  }
  // const OnClickRevertSoldDiamond = (issold) => {
  //   swal(Messages.diamondReverSoldProp).then(function (isConfirm) {
  //     if (isConfirm) {
  //       HttpService.postApi(API.SetSoldDiamondBySKU, {
  //         sku: props.props.data.sku,
  //         issold: issold
  //       }).then((response) => {
  //         props.onCloseModal(true)
  //       })
  //     }
  //   })
  // }

  return (
    <Modal
      show={props.props.IsShowModal}
      onHide={closeModal}
      keyboard={true}
    >
      <Modal.Header>
        <div>
          <h6>Virtual Ring Request</h6>
        </div>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={closeModal}
        ></button>
      </Modal.Header>
      <Modal.Body>
        <div className="content-wrapper p-0">
          <div className="row">
            <div className="col-lg-12 stretch-card">
              <div className="card">
                <div className="card-body">
                  <div className="row justify-content-between">
                    <div className="col-md-12">
                      <div className="card-header p-0 mb-3"></div>
                    </div>
                    <div className="col-md-12">
                      <div className="address-info">
                        <table className="table table-borderless table-diamond-detail">
                          <tbody>
                            {data !== undefined && (
                              <>
                                <tr>
                                  <td
                                    colSpan={2}
                                    className="text-center"
                                  >
                                    <img
                                      src={data.image}
                                      width={300}
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>Product Name:</td>
                                  <td>{data.product_name}</td>
                                </tr>
                                <tr>
                                  <td>SKU:</td>
                                  <td>{data.sku}</td>
                                </tr>
                                <tr>
                                  <td>Metal:</td>
                                  <td>{data.metal}</td>
                                </tr>
                                <tr>
                                  <td>Style:</td>
                                  <td>{data.style}</td>
                                </tr>
                                <tr>
                                  <td>Shape:</td>
                                  <td>{data.shape}</td>
                                </tr>
                                <tr>
                                  <td>Carat:</td>
                                  <td>{data.carat + ' ct.'}</td>
                                </tr>
                                <tr>
                                  <td>Name:</td>
                                  <td>{data.firstname + ' ' + data.lastname}</td>
                                </tr>
                                <tr>
                                  <td>Email:</td>
                                  <td>{data.email}</td>
                                </tr>
                                <tr>
                                  <td>Message:</td>
                                  <td>{data.message}</td>
                                </tr>
                              </>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default VirtualRingRequestDetail
